import { render } from "./NavbarAdmin.vue?vue&type=template&id=03292ac2"
const script = {}

import "./NavbarAdmin.vue?vue&type=style&index=0&id=03292ac2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__